/*
    模板设置左侧区域组件
    created by: liyaoh 2019-04-10
*/
import React, { Component } from 'react';
import withDragDropContext from "Pub/js/withDragDropContext";
import Ajax from "Pub/js/ajax";
import { connect } from "react-redux";
import Notice from "Components/Notice";
import AreaType from "./components/AreaType";
import NotMetaData from "./components/NotMetaData";
import LeftSideMetaTree from './components/LeftSideMetaTree';
import { langCheck } from 'Pub/js/utils';
import SetTemplateLeft from "./SetTemplate/setTemplateLeft";
import platform from "Pub/js/platform";
import { updateSelectArea, onToggleLeftSider } from "Store/ZoneSetting/action";
import { LEFT_SIDER_WIDTH } from './events';
import _ from 'lodash';
import { queryMetaTreeData, asyncQueryMetaPro, createMetaTreeIns, appendMetaTreeNodes, queryMetaPropByKeyWords } from './metatree/MetaTreeTools';
import MetaTreeModel from './metatree/MetaTreeModel';
const { NCDiv } = platform.base;

class MyLeftSider extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: 'meta',
            metaTree: [],
            origTree: null,
            targetAreaID: "",
            targetAreaType: "",
            canSelectTreeNodeList: [],
            currentArea: {},
            loading: false,
        };
    }

    changeTab = tabName => {
        this.setState({ activeTab: tabName });
    };

    //更新元数据树的数据
    updateMetaTreeData = ({ metaTree, origTree }) => {
        this.setState({
            metaTree,
            origTree,
        });
    };

    //判断是否需要去请求元数据
    loadMetaTree = (prevProps, prevState) => {
        let { isImplement, newAreaList, selectedArea, updateSelectArea } = this.props;
        let { metaTree, currentArea } = this.state;

        if (isImplement === false) {return false;}

        if (newAreaList.length && metaTree.length === 0 && Object.keys(currentArea).length === 0) {
            updateSelectArea(newAreaList.find(Boolean));
            return true;
        }

        if (Object.keys(selectedArea).length === 0 && Object.keys(prevProps.selectedArea).length !== 0) {
            return false;
        }

        if (prevProps.selectedArea && selectedArea) {
            return prevProps.selectedArea.code !== selectedArea.code;
        }
    };

    findActiveArea = prevProps => {
        let { newAreaList, selectedArea } = this.props;

        return prevProps.selectedArea.code !== selectedArea.code
            ? selectedArea
            : newAreaList.find(Boolean);
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        let { json } = this.props;
        if (this.loadMetaTree(prevProps, prevState)) {
            let defaultArea = this.findActiveArea(prevProps);

            if (defaultArea && (defaultArea.metaid === '' || defaultArea.metaid === null || defaultArea.metaid === undefined)) {
                this.setState({
                    metaTree: [],
                    targetAreaID: defaultArea.pk_area,
                    targetAreaType: defaultArea.areatype,
                    canSelectTreeNodeList: [],
                    currentArea: defaultArea,
                    loading: false,
                });
            } else {
                if (this.state.loading) {return;}
                this.setState({ loading: true });
                queryMetaTreeData.call(this, defaultArea.metaid, '').then(data => {
                    let treeData = { isleaf: false, readonly: false, refpk: defaultArea.metaid, refcode: '', pid: null, children: data };
                    let tree = createMetaTreeIns.call(this, treeData, defaultArea.areatype);
                    let resultTreeData = tree.getMetaTreeData();
                    let metaTree = resultTreeData.children;
                    // 数据类型205的，即可以全选该节点下面的叶子节点，需要模态框中显示select进行选择
                    let canSelectTreeNodeList = [];
                    _.forEach(metaTree, m => {
                        if (m.datatype === '205') {
                            canSelectTreeNodeList.push(m);
                        }
                    });
                    this.setState({
                        metaTree,
                        origTree: tree,
                        targetAreaID: defaultArea.pk_area,
                        targetAreaType: defaultArea.areatype,
                        canSelectTreeNodeList,
                        currentArea: defaultArea,
                        loading: false,
                    });
                });
            }
        }
    }

    calculateToggleIconPosition = () => {
        const { show, isImplement } = this.props;
        if (!isImplement) {
            return { left: show ? LEFT_SIDER_WIDTH : -11 };
        } else {
            return {};
        }
    };

    //切换左侧栏显隐
    toggleLeftSider = () => {
        this.props.onToggleLeftSider(!this.props.leftSiderShow);
    }

    render() {
        const { show, status, json, isImplement } = this.props;
        let { activeTab, loading } = this.state;
        let spreadHeight = isImplement && show === false ? 'spread-height' : '';
        return (
            <NCDiv
                className={`template-setting-left-sider-container ${spreadHeight}`}
                fieldid="left"
                areaCode={NCDiv.config.Area}
            >
                {
                    status &&
                    show &&
                    (
                        <div className='left-side-tab'>
                            <div
                                onClick={() => {
                                    this.changeTab('meta');
                                }}
                                className={activeTab === 'meta' && 'active'}
                            >
                                {/*元数据*/}
                                {langCheck('ZoneSetting-000247', 'pages', json)}
                            </div>

                            <div
                                onClick={() => {
                                    this.changeTab('notMeta');
                                }}
                                className={activeTab === 'notMeta' && 'active'}
                            >
                                {/*非元数据*/}
                                {langCheck('ZoneSetting-000202', 'pages', json)}
                            </div>
                        </div>
                    )
                }
                {/* <div
                    className={`toggle-left-btn ${show ? 'hide' : 'show'} ${isImplement ? 'implement' : ''}`}
                    style={this.calculateToggleIconPosition()}
                    onClick={this.toggleLeftSider}
                >
                    <i className="iconfont icon-mbpz_sq"></i>
                </div> */}
                <div className={`template-setting-sider template-setting-left-sider${isImplement ? ' implement' : ''}`} style={{ display: show ? 'block' : 'none' }}>

                    {!isImplement && <SetTemplateLeft multiOptions={this.props.multiOptions} />}
                    {!isImplement && <AreaType json={this.props.json} />}

                    {
                        activeTab === 'meta' &&
                        isImplement &&
                        loading === false &&
                        <LeftSideMetaTree
                            metaTree={this.state.metaTree}
                            origTree={this.state.origTree}
                            updateMetaTreeData={this.updateMetaTreeData}
                            json={json}
                            targetAreaID={this.state.targetAreaID}
                            canSelectTreeNodeList={this.state.canSelectTreeNodeList}
                            currentArea={this.state.currentArea}
                        />
                    }
                    {
                        isImplement !== true &&
                        <NotMetaData json={this.props.json} templettype={this.props.templettype} />
                    }
                    {
                        activeTab === 'notMeta' &&
                        isImplement &&
                        <NotMetaData json={this.props.json} templettype={this.props.templettype} />
                    }
                </div>
            </NCDiv>
        );
    }
}

function mapStateToProps(state) {
    return {
        newAreaList: state.zoneSettingData.newAreaList,
        selectedArea: state.zoneSettingData.selectedArea,
        isImplement: state.zoneSettingData.isImplement,
        leftSiderShow: state.zoneSettingData.leftSiderShow,
    };
}

export default connect(
    mapStateToProps,
    {
        updateSelectArea,
        onToggleLeftSider,
    },
)(withDragDropContext(MyLeftSider));
